import React from 'react';
import EbookLandingPageProduction from './components/EbookLandingPage/index';

function App() {
  return (
    <div className="App">
      <EbookLandingPageProduction />
    </div>
  );
}

export default App;